import React, { useEffect, useState } from 'react'
import Card from '../../../../common/card/Card'
import { useParams } from 'react-router-dom'
import { QueryClient, useQuery } from '@tanstack/react-query'
import { performRequest } from '../../../../common/utils'
import Loader from '../../../../common/loader/Loader'
import MembersTable from './MembersTable'
import useMemberTable from '../context/MemberTableContext'

const Members = ({teamType}) => {

  const params = useParams()
  const teamId = params.team_id
  const [ responseMessage, setResponseMessage ] = useState('')
  const { setRefetchMembers, setSelectedUser, setSelectedModal, setSelectedBulkUser } = useMemberTable()

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['get_team_members'],
      queryFn: requestTeamMembers,
      refetchOnWindowFocus: false
    }, queryClient)

    async function requestTeamMembers() {
      // const formData = new FormData()
      // formData.append('action', 'msync_get_team_members')
      // formData.append('team_id', teamId)
      // formData.append('team_type', teamType)
      // formData.append('nonce', group_dashboard.nonce_members)

      try {
        // const request = await performRequest(group_dashboard.ajaxurl, formData)
        // const res = await request.json()
        const res = await Tangible?.ajax('msync_get_team_members', {
          team_id: teamId,
          team_type: teamType
        })
        if (!res.success) {
          throw new Error( res.errors.shift() )
        }
        return res.team_members
      } catch (error) {
        console.log(error)
        setResponseMessage( error.toString() )
        return false
      }
    }

  useEffect(() => {
    setRefetchMembers(() => refetch)
    setSelectedUser('')
    setSelectedModal('')
    setSelectedBulkUser('')
  }, [ refetch ])

  if( isLoading || isPending || isFetching ){
    return (
      <Loader type='spinner-dual-ring'/>
    )
  }

  if( isError ){
    return (
      <Card> 
        <strong> { error.message } </strong> 
      </Card>
    )
  }

  return (
    <>
      {
        responseMessage && responseMessage !== ''
        ? <Card> 
            <div class="msync-card__body"><strong>{ responseMessage }</strong></div>
          </Card>
        : data &&
          <MembersTable membersData={ data } />
      }
    </>
  )
}

export default Members
